module.exports = __webpack_public_path__ + "img/taps.3d94f9f0.svg";